import React, { Component } from "react";

export default class OutstandingLeavesStatistics extends Component {
  get leaveApplicationsCount() {
    return this.props.outstandingLeaves.length;
  }

  get branchesCount() {
    return new Set(
      this.props.outstandingLeaves.map((leave) => {
        return leave.branch_id;
      })
    ).size;
  }

  get departmentsCount() {
    return new Set(
      this.props.outstandingLeaves.map((leave) => {
        return leave.departments_id;
      })
    ).size;
  }

  render() {
    return (
      <div className="row" style={styles.sectionMargin}>
        <span style={styles.redTextHeading}>
          Total {this.leaveApplicationsCount}
        </span>
        <span style={styles.blueTextNormal}>{this.branchesCount} Branches</span>
        <span style={styles.blueTextNormal}>
          {this.departmentsCount} Departments
        </span>
      </div>
    );
  }
}

const styles = {
  sectionMargin: {
    margin: "25px 10px",
    display: "flex",
    alignItems: "center",
  },
  redTextHeading: {
    color: "#FF0000",
    fontSize: 20,
    fontWeight: "bold",
    marginRight: "50px",
  },
  blueTextNormal: {
    color: "#27568a",
    fontSize: 12,
    marginRight: "50px",
  },
};
